import { render, staticRenderFns } from "./-FormBase.vue?vue&type=template&id=8f4db74e"
import script from "./-FormBase.vue?vue&type=script&lang=js"
export * from "./-FormBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports